module.exports = __webpack_public_path__ + "img/ico_FF.0670b741.png";